import IntroductionContainer from '../components/IntroductionContainer/IntroductionContainer.vue';
import IntroductionAcceptPage from '../components/IntroductionAcceptPage/IntroductionAcceptPage.vue';

export default {
    path: '/introduction',
    component: IntroductionContainer,
    meta: {
        unauthenticated: true
    },
    children: [
        {
            path: '/introduction/:confirmationToken',
            component: IntroductionAcceptPage
        }
    ]
};



// WEBPACK FOOTER //
// ./src/routes/routes-introduction.js